export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-cath-kidston-9a2a3d18d1123980104f05c7d802cf07.png";